import axios from '@/plugins/axios.js'

// 获取版本号
export const getVersion = () => axios.get('/tb-firmware/edmVersion')

// 获取音频列表
export const getAudioSupport = () => axios.get('/tb-firmware/audioSupport')

// 获取视频支持列表
export const getvideoSupport = () => axios.get('/tb-firmware/videoSupport')